import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from '@storable/canaveral-components';
import Authorization from 'web/containers/Authorization';

const { Navbar } = Layout;

const propTypes = {
  active: PropTypes.bool,
  authorization: PropTypes.shape({
    action: PropTypes.string,
    subject: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
  }),
  hideUnauthorized: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

const defaultProps = {
  active: undefined,
  hideUnauthorized: undefined,
};

const getAuthorizationProps = (authorized, props) => (!authorized ? {
  unauthorized: true,
  text: `You do not have permission to ${props.text}. Please contact support.`,
} : {});

const AdminNavbarItem = ({ authorization, hideUnauthorized, ...props }) => {
  if (!authorization) {
    return (
      <Navbar.Item {...props} />
    );
  }

  return (
    <Authorization {...authorization}>
      {(authorized) => {
        if (!authorized && hideUnauthorized) {
          return null;
        }

        return (
          <Navbar.Item
            {...props}
            {...getAuthorizationProps(authorized, authorization)}
          />
        );
      }}
    </Authorization>
  );
};

AdminNavbarItem.propTypes = propTypes;
AdminNavbarItem.defaultProps = defaultProps;

export default AdminNavbarItem;
